import * as z from 'zod'

import { PET_CONSTANTS } from '@flows/configs/petHealth/constants'
import { DEDUCTIBLE_HEADER } from '@flows/configs/shared/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyCustomComponent } from '@flows/core/types/CustomComponent'
import type { TransformedOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'
import Schema_Quote from '@flows/insurance/schemas/shared/Schema_Quote'

const pet_quote = (params: StepConfigParams) => {
  const quoteStep = {
    type: 'customComponent',
    name: 'QuoteStep',
    props: {
      product: 'pet_health_v1_getsafe_de',
      headerTitle: {
        type: 'translatableText',
        translationKey: 'sharedFlows_petHealth:steps.pet_quote.title',
        values: {
          pet_name: {
            type: 'dynamicValue',
            path: params.helperFunctions.getParamPath('pet_name'),
          },
        },
      },
      configurableParameters: [
        DEDUCTIBLE_HEADER({
          title: 'sharedFlows_common:steps.deductibles.percent',
          modalTitle: 'sharedFlows_common:generic.deductible.percent.title',
          modalInfo: 'sharedFlows_petHealth:steps.pet_quote.deductible.percent.info',
        }),
        {
          type: 'dropDown',
          label: {
            type: 'translatableText',
            translationKey: 'sharedFlows_petHealth:steps.pet_quote.deductibles.label',
          },
          useFilterInput: false,
          styleType: 'outlined',
          name: params.helperFunctions.getParamPath('deductible_percentage'),
          options: PET_CONSTANTS.deductibleOptions.map((option): TransformedOption => {
            return {
              label: {
                type: 'nonTranslatableText',
                text: params.clientHelpers.formatter.formatPercent(option),
              },
              value: Number(option),
            }
          }),
        },
      ],
    },
    inputs: [],
    outputs: [],
  } as const satisfies AnyCustomComponent
  return {
    validationStrategy: 'onChange',
    schema: Schema_Quote.merge(
      schemaUtils.generateZodObjectFromPaths({
        [params.helperFunctions.getParamPath('deductible_percentage')]:
          BaseSchema_PetHealthV1GetsafeDe.shape.deductible_percentage,
        [params.helperFunctions.getParamPath('tariff_line')]:
          BaseSchema_PetHealthV1GetsafeDe.shape.tariff_line,
        [params.helperFunctions.getParamPath('tariff_type')]:
          BaseSchema_PetHealthV1GetsafeDe.shape.tariff_type,
        product_keys: z.object({ pet_health_v1_getsafe_de: z.boolean().optional() }).optional(),
      })
    ),
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareQuoteStep',
        options: {
          productKey: params.productKey,
        },
        inputs: [],
        outputs: [],
      },
    },
    showOrderSummary: true,
    nonStickyFooter: true,
    stepContent: [quoteStep],
    subFlow: params.subFlow,
    nextStep: 'pet_chipped',
  } as const satisfies AnyStepConfiguration
}

export default pet_quote
